<div class="dialogContainer">
  <div class="content">
    <H2>
    Update Opportunity
  </H2>
  <div class="message">
    The opportunity associated to this quote hasn't been updated in 90 days.
    Please update the following fields to continue.
  </div>
  <div class="inputRow">
    <table>
      <tr>
        <td class="titleCell">Status:</td>
        <td>
          <mat-form-field>
            <mat-select [(ngModel)]="opportunity.statusCode" (selectionChange)="updateHasFields()">
              @for (status of statuses(); track status) {
                <mat-option [value]="status.code">{{ status.description }}</mat-option>
              }
            </mat-select>
            @if (!hasStatus()) {
              <mat-hint class="updateRequired">*Status must be updated</mat-hint>
            }
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="titleCell">Phase:</td>
        <td>
          <mat-form-field>
            <mat-select [(ngModel)]="opportunity.currentPhaseCode" (selectionChange)="updateHasFields()">
              @for (phase of phases(); track phase) {
                <mat-option [value]="phase.code">{{ phase.description }}</mat-option>
              }
            </mat-select>
            @if (!hasPhase()) {
              <mat-hint class="updateRequired">*Phase must be updated</mat-hint>
            }
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class=" titleCell">Est. 1st Ship Date:
        </td>
        <td>
          <mat-form-field>
            <input matInput [matDatepicker]="picker" [(ngModel)]="opportunity.expectedFirstShipmentDate">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker [startAt]="dateStartValue()"></mat-datepicker>
          </mat-form-field>
        </td>
      </tr>
    </table>
  </div>
  <div class="buttonRow">
    <span class="spacer"></span>
    <button [disabled]="!isValid()" class="dialogButton primary-button" matButton="elevated"
      (click)="update()">Update
    </button>
  </div>
</div>
